<template>
  <div>
    <MainForm
      :name="FORM_NAMES.offer"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      :ui-form="uiForm"
    >
      <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.appointment"
        ui-error-message="Please review the fields marked in red"
        :ui-title="`${dynamicText}`"
        :ui-subtitle="`${dynamicTextName} You qualify for a ${BRAND.loan}!
         We just need some more information from you to finalize your offer.`"
      >
           <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.homeAddress"
          :ui-title="titleHome"
        >
          <UiWrapper :name="FIELD_NAMES.homeAddress">
            <Choice
              :options="[
                {
                  value: 'HOME',
                  label: 'Residential Address',
                },
              ]"
            />
          </UiWrapper>
        </FieldsetModel>

        <!-- Home -->

        <FieldsetModel :ui="uiBaseFieldset" name="fieldSetHome" ui-columns="2">
          <UiWrapper
            :name="FIELD_NAMES.addressLine1Home"
            label="Address Line 1"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.addressLine2Home"
            label="Address Line 2"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.residentialEmirateHome"
            label="Emirate"
            optional
          >
            <Dropdown
              placeholder="Emirate"
              v-bind:selected="`selected`"
              :options="EMIRATE_LIST_CARD"
            />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.homeCountryCountryHome"
            label="Country"
            optional
          >
            <Suggest
              :exact-match="true"
              placeholder="Country"
              :get-formatted-item="formatMatchedString"
              :get-suggestions="getCountriesAppointment"
            />
          </UiWrapper>

          <UiWrapper
            :name="FIELD_NAMES.poBoxHome"
            label="PO Box"
            optional
            :validations="pinCodeValidations"
          >
            <InputText />
          </UiWrapper>
        </FieldsetModel>
           <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.localReference"
          ui-title="Please provide us with one local reference contact details(It could be your friend/colleague)"
        >
          <UiWrapper
            :name="FIELD_NAMES.fullNameRefernce"
            label="Name"
            :validations="[
              {
                errorMessage: 'Field contains invalid characters',
                condition: patternCondition(NAMES_CHARS),
                name: 'lastname-chars',
              },
            ]"
          >
            <InputText />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.referencePhoneNumber"
            label="Mobile Number"
            :validations="validations"
          >
            <InputText type="tel" :prefix="prefix" :maxlength="maxlength" />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          ui-title="Please provide your home country reference contact details (family member/relative only)"
          :name="FIELDSET_NAMES.homeCountryReference"
          ui-columns="2"
        >
          <UiWrapper
            :name="FIELD_NAMES.fullNameHomecountry"
            label="Name"
            :validations="[
              {
                errorMessage: 'Field contains invalid characters',
                condition: patternCondition(NAMES_CHARS),
                name: 'lastname-chars',
              },
            ]"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.homeCountryPhoneCountryCode"
            label="Country code"
          >
            <Dropdown placeholder="Country code" :options="MAPPED_PHONE_CODE" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.homeCountryPhone"
            label="Mobile Number"
            :validations="validationsGlobal"
          >
            <InputText
              type="tel"
              :minlength="minlength"
              :maxlength="minlengthGlobal"
            />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          ui-title="Please provide your home country address"
          name="homeCountryAddress"
          ui-columns="2"
        >
          <UiWrapper
            :name="FIELD_NAMES.homeCountryAddress"
            label="Address Line 1"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.homeCountryAdditionalAddress"
            label="Address Line 2"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>

          <UiWrapper
            :name="FIELD_NAMES.homeCountryCountry"
            label="Country"
            optional
          >
            <Suggest
              :exact-match="true"
              placeholder="Country"
              :get-formatted-item="formatMatchedString"
              :get-suggestions="getCountries"
            />
          </UiWrapper>

          <UiWrapper
            :name="FIELD_NAMES.homeCountryPoscode"
            label="PO Box"
            optional
            :validations="pinCodeValidations"
          >
            <InputText />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>
    </MainForm>
  </div>
</template>

<script>
// Models
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import FIELDSET_NAMES from "@/forms/constants/fieldset-names";
// Ui Wrappers
import UiWrapper from "@/forms/components/base/ui-wrapper";
import DateWrapper from "@/forms/components/ui-dunia/date-wrapper";
// // Shared Comps
// import FieldsetAppointmentAddress from "@/forms/components/card/credit-card/steps/fieldsets/appointment-date";
import StepAdditionalInformation from "@/forms/components/shared/steps/additional-information";
import FieldsetAppointmentDate from "@/forms/components/cards/stp-card/steps/fieldsets/appointment-date";
import StepSupplementaryCard from "@/forms/components/shared/steps/supplementary-card";

// Ui Components
import {
  InputText,
  InputSlide,
  Dropdown,
  PlainText,
  Choice,
  Feedback,
  InputTime,
  Suggest
} from "@dunia/ui";

// Utils
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
// Constants
import FIELD_NAMES from "@/forms/constants/field-names";
import { isFutureDateCondition, withinMonthRange } from "@/forms/conditions";
import sharedComponentMixin from "@/forms/components/shared/shared-component-mixin";
import * as conditions from "@/forms/conditions";
import { patternCondition } from "@/forms/conditions";
import {
  APPOINTMENT_PLACE_OPTIONS,
  AT_MY_OFFICE,
  NOMINEE_RELATIONSHIP_OPTIONS,
  MOBILE_STARTING_NUMBER,
  MOBILE_NUMBER_LENGTH,
  MOBILE_NUMBER_LENGTH_GLOBAL,
 DIGIT_CHARS,
  NAMES_CHARS,
  MAPPED_PHONE_CODE,
  ADDRESS_CHARS,
} from "@/forms/constants/onboarding-logic";
import { USE } from "@/forms/constants/nbc-logic";
import store from "@/store";
import { SET_OFFER_REJECTED } from "@/lib/constants/mutations";
import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";
export default {
  name: "OnboardDunia",

  mixins: [FormComponentMixin, sharedComponentMixin],

  components: {
    // Components
    InputSlide,
    PlainText,
    MainForm,
    StepModel,
    InputText,
    Dropdown,
    Suggest,
    FieldsetModel,
    UiWrapper,
    Choice,
    FieldsetMobilePhone,
    FieldsetFullName
  },
  props: {
    name: {
      type: String,
      default: FIELDSET_NAMES.appointmentSetDate
    },
    title: {
      type: String,
      default: "When would you like to meet?"
    },
    timeOptions: {
      type: Array,
      default: () => [
        {
          value: "7am - 9am",
          label: "7am - 9am"
        },
        {
          value: "9am - 11am",
          label: "9am - 11am"
        },
        {
          value: "11am - 1pm",
          label: "11am - 1pm"
        },
        {
          value: "1pm - 3pm",
          label: "1pm - 3pm"
        },
        {
          value: "3pm - 5pm",
          label: "3pm - 5pm"
        },
        {
          value: "5pm - 7pm",
          label: "5pm - 7pm"
        }
      ]
    },
    validations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-mobile-only-digits"
        },
        {
          errorMessage: "Your phone must start with a 5",
          condition: conditions.patternCondition(MOBILE_STARTING_NUMBER),
          name: "check-is-mobile-starting-number"
        },
        {
          errorMessage: "Your phone must have 9 digits",
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH),
          name: "check-is-mobile-length"
        }
      ]
    },
    validationsGlobal: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-mobile-only-digits"
        },

        {
          errorMessage: "Your phone must be between 9-11 digits",
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH_GLOBAL),
          name: "check-is-mobile-length"
        }
      ]
    },
  addressValidations: {
      type: Array,
      default: () => [
        {
          errorMessage:
            "Field contains invalid characters. Albhabets, Numbers and special character (- , / space) are allowed.",
          condition: patternCondition(ADDRESS_CHARS),
          name: "address-chars",
        },
      ],
    },
    pinCodeValidations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Field contains invalid characters.",
          condition: patternCondition(DIGIT_CHARS),
          name: "pincode-chars",
        },
      ],
    },
    prefix: {
      type: String,
      default: "+971"
    },
    maxlength: {
      type: Number,
      default: 9
    },
    minlength: {
      type: Number,
      default: 9
    },
    minlengthGlobal: {
      type: Number,
      default: 11
    }
  },
  data: () => ({
    USE_LOAN_OPTIONS: USE,
    APPOINTMENT_PLACE_OPTIONS,
    NOMINEE_RELATIONSHIP_OPTIONS
  }),
  computed: {
    isAppointmentPlaceSelected() {
      return !!this.fieldValues(FIELD_NAMES.appointmentPlace);
    },

    isAppointmentAtOffice() {
      return this.fieldValues(FIELD_NAMES.appointmentPlace) === AT_MY_OFFICE;
    },

    showAppointmentAddress() {
      return !this.isCompanyListed || this.isAppointmentPlaceSelected;
    },
    creditCardType() {
      var cardType = this.$store.state.productTypeFromCreditScoreCalculation;
      return `Deem ${cardType}!`;
    },
    getAppianCardType() {
      return this.$store.state.appianCardType;
    },
     dynamicText() {
      var r1 = "";
      if (!window.matchMedia("screen and (max-width: 700px)").matches) {
        r1 = "Congratulations " + this.userName;
      } else {
        r1 = "Congratulations";
      }
      return r1;
    },
    dynamicTextName() {
      var r1 = "";
      if (!window.matchMedia("screen and (max-width: 700px)").matches) {
        r1 = "";
      } else {
        r1 = this.userName + "!";
      }
      return r1;
    },
  },

  methods: {
    finishCallback() {
      var employeeCodes = this.$store.state.employeeCodes;
      var subtitleMessage = "";
      var titleMessage = "";
      if (this.$store.state.employeeCodes) {
        titleMessage = `Approved!`;
        subtitleMessage = `Congratulations ${this.userName}, you qualify for a Deem Personal Loan for up to AED ${this.getAppianPrescreened}.  
          Your customer identification number is ${this.getCifNumber}.`;
      } else {
       titleMessage = `Congratulations  ${this.userName}!`;
        subtitleMessage = `You are approved for a Deem Personal Loan. Our team will be in touch with you shortly. We have sent a link on your personal email to upload your documents.`;
      }
      this.showEndPage({
        title: titleMessage,
        subtitle: subtitleMessage
        //actionNameEndForm: "Thanks"
      });
    }
    //}
  }
  
};

</script>

